import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { PageBody, PageHead, Tabs } from '../../components/aa';
import { AppsPermissionsPanel } from '../../components/settings/OwnerSettingsPanels';
import { McpSettingsPanel } from '../../components/settings/McpSettingsPanel';

const TABS = [
  { id: 'apps', label: 'Apps' },
  { id: 'mcp', label: 'MCP servers' },
];

const ConnectorsPage: React.FC = () => {
  const clientId = localStorage.getItem('client_id') || '';
  const [params] = useSearchParams();
  let initialTab = 'apps';
  if (params.get('tab') === 'mcp') initialTab = 'mcp';
  const [tab, setTab] = useState(initialTab);
  return (
    <PageBody>
      <PageHead title="Connectors" sub="Every app and MCP server your company connects, and who may use it." />
      <Tabs tabs={TABS} active={tab} onChange={setTab} label="Connectors" className="mb-5" />
      {tab === 'apps' && <AppsPermissionsPanel clientId={clientId} />}
      {tab === 'mcp' && <McpSettingsPanel />}
    </PageBody>
  );
};

export default ConnectorsPage;
